import React from "react";
import { FaSearch } from "react-icons/fa";

const SearchBar = ({ placeholder, searchQuery, onSearch }) => (
  <div className="relative max-w-md w-full">
    <input
      type="text"
      className="w-full px-4 py-3 border border-gray-300 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-[#4CAF50] focus:border-[#4CAF50] placeholder-gray-400 transition-all text-gray-700"
      placeholder={placeholder}
      value={searchQuery}
      onChange={(e) => onSearch(e.target.value)}
    />
    <FaSearch className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 transition" />
  </div>
);

export default SearchBar;
